import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Buyer } from '../../../services/buyer';

@Component({
  selector: 'app-banner',
  standalone: false,
  templateUrl: './banner.html',
  styleUrl: './banner.less'
})
export class Banner implements OnInit {
  articleSelected:any;
  constructor(private router: Router,private buyer:Buyer){

  }

  ngOnInit(): void {
    
  }
  navigateToTradeGPT() {
    this.router.navigate(['/trade-gpt'], {
      state: { focusField: 'targetInput' }
    })
  }

  viewQuotes(id:any){
     this.buyer.getCatalogById(id).subscribe({
      next:(res:any)=>{
        this.articleSelected = res;
        this.router.navigate(['/buyer/catalog/view-seller-quotes'], {
        state: { article: JSON.stringify(this.articleSelected) }
      })
      }
     })
    
    
  }
}
